import api from './api';

export interface Agent {
  id: number;
  name: string;
  contact_number?: string;
  email?: string;
  team_id?: number;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  team?: {
    id: number;
    name: string;
  } | null;
  customers_count?: number;
}

export interface CreateAgentData {
  name: string;
  contact_number?: string;
  email?: string;
  team_id?: number;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const agentService = {
  async getAll() {
    const response = await api.get('/agents');
    return response.data;
  },

  async create(data: CreateAgentData): Promise<Agent> {
    const response = await api.post('/agents', data);
    return unwrap<Agent>(response);
  },

  async update(id: number, data: Partial<CreateAgentData>): Promise<Agent> {
    const response = await api.put(`/agents/${id}`, data);
    return unwrap<Agent>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/agents/${id}`);
  },
};

